import { render, staticRenderFns } from "./DeviceGroupCreate.vue?vue&type=template&id=a04af4c6&scoped=true&"
import script from "./DeviceGroupCreate.vue?vue&type=script&lang=js&"
export * from "./DeviceGroupCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a04af4c6",
  null
  
)

export default component.exports